import { graphql, useStaticQuery } from 'gatsby';

const useNavbars = () => {
  const { sanityNavbars } = useStaticQuery(graphql`
    query useNavbarsQuery {
      sanityNavbars {
        useDarkIcons
        isGradientBg
        hasOffer
        navOfferIcon {
          alt
          asset {
            gatsbyImageData(placeholder: BLURRED, formats: WEBP)
          }
        }
        navOfferLabel
        navItem {
          type
          dropdownLabelLink {
            name
            slug {
              current
            }
            heroBgImg {
              alt
              asset {
                gatsbyImageData(placeholder: BLURRED, formats: WEBP)
              }
            }
          }
          dropdownFooterLink {
            name
            slug {
              current
            }
            heroBgImg {
              alt
              asset {
                gatsbyImageData(placeholder: BLURRED, formats: WEBP)
              }
            }
          }
          dropdownFooterLinkAnchorText
          dropdownTextLabel
          dropdown {
            type
            dropdownTextLabel
            singlePageLink {
              name
              subtitle
              slug {
                current
              }
              heroBgImg {
                alt
                asset {
                  gatsbyImageData(placeholder: BLURRED, formats: WEBP)
                }
              }
            }
          }
          singlePageLink {
            name
            subtitle
            slug {
              current
            }
            heroBgImg {
              alt
              asset {
                gatsbyImageData(placeholder: BLURRED, formats: WEBP)
              }
            }
          }
        }
        navCtaButtonLabel
        navCtaButtonLink {
          name
          slug {
            current
          }
          heroBgImg {
            alt
            asset {
              gatsbyImageData(placeholder: BLURRED, formats: WEBP)
            }
          }
        }
      }
    }
  `);

  return sanityNavbars;
};

export { useNavbars };
